{
  "title": "Host Resource Monitor",
  "loading": "Loading",
  "disconnected": "Disconnected",
  "lastUpdate": "Last update",
  "refresh": "Refresh",
  "days": "d",
  "free": "Free",
  "hostCpu": "Host CPU Usage",
  "hostMemory": "Host Memory Usage",
  "diskFree": "Disk Free Space",
  "uptime": "System Uptime",
  "app": {
    "title": "Application Resources",
    "cpu": "App CPU Usage",
    "memory": "App Memory",
    "memoryTip": "This is the process working set resident in physical RAM (including pages shared with the system). It may differ from Task Manager: the \"Details\" tab shows the active private working set (shared pages excluded, active portion only), a narrower metric and thus usually smaller; this value is closer to Task Manager's \"Processes\" tab. Both are correct \u2014 they simply measure differently.",
    "threads": "Threads"
  }
}